<template>
    <page-table/>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'order-cancelComfirm',
  components: {
    PageTable,
  },
}
</script>